import { Component } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-battery-solutions',
  standalone: true,
  templateUrl: './battery-solutions.component.html',
  styleUrl: './battery-solutions.component.scss',
  imports: [HeaderComponent, FooterComponent, RouterLink]
})
export class BatterySolutionsComponent {
  email: string = 'sales@sprucepower.com';
}
